/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseAppearanceFieldLayout } from './DatabaseAppearanceFieldLayout';
import {
    DatabaseAppearanceFieldLayoutFromJSON,
    DatabaseAppearanceFieldLayoutFromJSONTyped,
    DatabaseAppearanceFieldLayoutToJSON,
} from './DatabaseAppearanceFieldLayout';
import type { DatabaseAppearancePropertiesDefaultViewColumns } from './DatabaseAppearancePropertiesDefaultViewColumns';
import {
    DatabaseAppearancePropertiesDefaultViewColumnsFromJSON,
    DatabaseAppearancePropertiesDefaultViewColumnsFromJSONTyped,
    DatabaseAppearancePropertiesDefaultViewColumnsToJSON,
} from './DatabaseAppearancePropertiesDefaultViewColumns';
import type { DatabaseAppearancePropertiesDetailsBodyWidthPercent } from './DatabaseAppearancePropertiesDetailsBodyWidthPercent';
import {
    DatabaseAppearancePropertiesDetailsBodyWidthPercentFromJSON,
    DatabaseAppearancePropertiesDetailsBodyWidthPercentFromJSONTyped,
    DatabaseAppearancePropertiesDetailsBodyWidthPercentToJSON,
} from './DatabaseAppearancePropertiesDetailsBodyWidthPercent';
import type { DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent } from './DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent';
import {
    DatabaseAppearancePropertiesQuestionnaireBodyWidthPercentFromJSON,
    DatabaseAppearancePropertiesQuestionnaireBodyWidthPercentFromJSONTyped,
    DatabaseAppearancePropertiesQuestionnaireBodyWidthPercentToJSON,
} from './DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent';
import type { DatabaseContentPage } from './DatabaseContentPage';
import {
    DatabaseContentPageFromJSON,
    DatabaseContentPageFromJSONTyped,
    DatabaseContentPageToJSON,
} from './DatabaseContentPage';
import type { DatabaseDetailmaskeProperties } from './DatabaseDetailmaskeProperties';
import {
    DatabaseDetailmaskePropertiesFromJSON,
    DatabaseDetailmaskePropertiesFromJSONTyped,
    DatabaseDetailmaskePropertiesToJSON,
} from './DatabaseDetailmaskeProperties';
import type { DatabaseFarbrollen } from './DatabaseFarbrollen';
import {
    DatabaseFarbrollenFromJSON,
    DatabaseFarbrollenFromJSONTyped,
    DatabaseFarbrollenToJSON,
} from './DatabaseFarbrollen';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseHeaderProperties } from './DatabaseHeaderProperties';
import {
    DatabaseHeaderPropertiesFromJSON,
    DatabaseHeaderPropertiesFromJSONTyped,
    DatabaseHeaderPropertiesToJSON,
} from './DatabaseHeaderProperties';
import type { DatabaseNavigationProperties } from './DatabaseNavigationProperties';
import {
    DatabaseNavigationPropertiesFromJSON,
    DatabaseNavigationPropertiesFromJSONTyped,
    DatabaseNavigationPropertiesToJSON,
} from './DatabaseNavigationProperties';
import type { DatabaseSchriftrollen } from './DatabaseSchriftrollen';
import {
    DatabaseSchriftrollenFromJSON,
    DatabaseSchriftrollenFromJSONTyped,
    DatabaseSchriftrollenToJSON,
} from './DatabaseSchriftrollen';

/**
 * 
 * @export
 * @interface DatabaseAppearanceProperties
 */
export interface DatabaseAppearanceProperties {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    hideHeader?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    hideContent?: boolean;
    /**
     * hide the column count slider in grid/card view
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    hideColumnSlider?: boolean;
    /**
     * hide paging, page-size select and scroll-to-top in list/grid/gallery views (desktop AND mobile). The add button stays visible — without it there would be no way left to create an entry from the list.
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    hidePaginationBar?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    hideFooter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    hideAccountIcon?: boolean;
    /**
     * show list entries as cards on mobile instead of table rows
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    mobileCardView?: boolean;
    /**
     * Kennung des gewaehlten Farbkonzepts aus dem neuen Farbsystem ("datenbankgestalter", "hell", "dark", "bunt", "eleganz", "natur", "ozean", "monochrom", "retro", "sunshine", "info").
     * Das neue System fuehrt vierzehn Rollen: zehn fuer die Uebersichten (Liste, Grid, Galerie) und vier fuer Kopf- und Fussbereich. Es steht NEBEN den bestehenden Einzelfarben, nicht an ihrer Stelle — die Ansichten ziehen nach und nach um, und bis dahin muss beides gelten. Ist kein Konzept gewaehlt, werden die Rollen aus den alten Werten abgeleitet.
     * SEIT DEM 28.08.2026 GILT ES AUCH FUER DIE DETAILMASKE. Sie hatte bis dahin 37 eigene `--db-details-*`-Werte; die Farben darunter folgen jetzt den Rollen. Schriftart und Schriftgroesse bleiben einzeln einstellbar — sie sind keine Farbrollen.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    farbkonzept?: string;
    /**
     * 
     * @type {DatabaseDetailmaskeProperties}
     * @memberof DatabaseAppearanceProperties
     */
    detailmaske?: DatabaseDetailmaskeProperties;
    /**
     * Der Uebergang der Diashow im Stil FOTOALBUM.
     * Vorgabe des Betreibers 05.10.2026 mit seinem Entwurf `fotoalbum_prototyp.html`: zehn Stile zur Wahl. Neun davon blenden ein einzelnes Bild ueber die Flaeche ein; FOTOTISCH ist die Ausnahme -- dort liegen alle Fotos als Polaroids auf einer Holzflaeche, und das laufende hebt sich heraus.
     * NICHT JE GERAET, wie der Bibliotheks-Stil selbst: Es ist die Gestalt der Vorlage, keine Frage des Platzes.
     * FEHLT DER WERT, gilt FOTOTISCH -- der Entwurf hat ihn vorgewaehlt.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    bibDiashow?: DatabaseAppearancePropertiesBibDiashowEnum;
    /**
     * Sekunden je Bild in der Diashow des Stils FOTOALBUM.
     * FEHLT DER WERT, gilt 4. Unter 2 waere es ein Flackern, ueber 30 stuende die Show still -- die Oberflaeche bietet deshalb nur Werte dazwischen an.
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    bibDiashowTakt?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    bibKarussell?: DatabaseAppearancePropertiesBibKarussellEnum;
    /**
     * Der Bibliothek-Stil der Vorlage "Bibliothek" (TPL_BIBLIOTHEK).
     * NUR IM KONFIGURATIONSMODUS DER DESIGNVORLAGE einzutragen (Vorgabe des Betreibers 01.10.2026). Er gehoert zur Vorlage, nicht zur einzelnen Datenbank: Eine "Rezeptkartei" ist eine Kartei, auch wenn jemand anderes Rezepte darin fuehrt.
     * IST EIN STIL HINTERLEGT, GIBT ES NUR DIESEN STIL. Liste, Kacheln und Galerie entfallen dann, und die Wahl der Ansicht verschwindet aus der Bedienung — eine Einstellung, die nichts bewirkt, ist schlimmer als keine: Man sucht den Fehler bei sich.
     * FEHLT DER WERT, verhaelt sich die Datenbank wie jede andere: Liste, Kacheln und Galerie stehen zur Wahl. Das ist zugleich der Rueckfall fuer jede Vorlage, die den Stil nie gesetzt hat.
     * KEINE ANGABE JE GERAET, anders als Aufbau und Knopfform der Detailmaske: Der Stil ist die Gestalt der Vorlage, keine Frage des Platzes. Dass ein Regal auf dem Telefon schmaler steht, loest das Layout selbst.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    bibliothekStil?: DatabaseAppearancePropertiesBibliothekStilEnum;
    /**
     * Zeigt die Buchstabenleiste A-Z ueber der Bibliotheks-Uebersicht.
     * HINZUSCHALTBAR, NICHT GESETZT (Vorgabe des Betreibers 01.10.2026: "Aber A B C sowie Stichworte muessen wir hinzuschaltbar machen"). Eine Songbibliothek mit zweitausend Titeln braucht sie, eine Rezeptkartei mit dreissig nicht - dort stuenden fuenfundzwanzig blasse Buchstaben ueber vier benutzten.
     * SIE FILTERT NACH DEM ANFANGSBUCHSTABEN DES TITELFELDES, also der Zuordnung "bibTitel". Buchstaben ohne Treffer sind blass und nicht anklickbar - wie im Lexikon, damit niemand ins Leere greift.
     * Fehlt der Wert, erscheint die Leiste nicht.
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    bibBuchstabenleiste?: boolean;
    /**
     * Zeigt die Stichwortleiste ueber der Bibliotheks-Uebersicht.
     * HINZUSCHALTBAR wie die Buchstabenleiste. Sie listet die tatsaechlich vergebenen Werte der Zuordnung "bibStichwort" - nicht die moeglichen: Ein Schlagwort, das niemand benutzt hat, ist ein Knopf, der eine leere Flaeche zeigt.
     * IST DAS FELD NICHT ZUGEORDNET, erscheint die Leiste nicht, auch wenn der Schalter an ist. Sonst stuende ein leerer Streifen da, und der Fehler sieht nach einem Fehler des Produkts aus.
     * Fehlt der Wert, erscheint die Leiste nicht.
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    bibStichwortleiste?: boolean;
    /**
     * Der Tag, an dem Tuerchen 1 des Adventskalenders (TPL_ADVENT) aufgeht, als "YYYY-MM-DD". Tuerchen n oeffnet n-1 Tage spaeter.
     * AN DER DATENBANK, NICHT AN DER DESIGNVORLAGE: Er aendert sich jedes Jahr. Der Stil einer Vorlage gehoert ihr dauerhaft, dieses Datum niemals - eine Vorlage mit dem 1. Dezember 2026 darin waere im Januar falsch und muesste jaehrlich angefasst werden.
     * EIN DATUM STATT EINER JAHRESZAHL, damit der Kalender auch vor etwas anderem herzaehlen kann als vor Weihnachten - vierundzwanzig Tage vor einer Hochzeit, einem Umzug, einer Eroeffnung.
     * FEHLT DER WERT, gilt der 1. Dezember des laufenden Jahres. Ihn als "kein Kalender" zu lesen hiesse, dass eine frisch angelegte Datenbank vierundzwanzig verschlossene Tuerchen ohne Datum zeigt.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    adventStart?: string;
    /**
     * Duerfen vergangene Tuerchen noch geoeffnet werden?
     * AN        Ein verpasstes Tuerchen bleibt offen (Vorgabe). AUS       Sein Tag vergeht, und der Inhalt ist fort.
     * VOR SEINEM TAG GEHT NIE EINES AUF - das ist keine Einstellung, sondern die Regel des Kalenders. Dieser Schalter betrifft ausschliesslich die Vergangenheit.
     * FEHLT DER WERT, gilt AN. Der Kalender, den jeder kennt, bleibt offen; wer ihn streng haben will, stellt das ausdruecklich ein. Umgekehrt verloeren bestehende Datenbanken bei jedem Nachzuegler ihren Inhalt, ohne dass jemand etwas geaendert haette.
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    adventNachtraeglich?: boolean;
    /**
     * Die Form einer Speisekarte (TPL_SPEISEKARTE): A la carte, eine einfache Liste, ein Menue mit Gaengen oder ein Buffet mit Stationen. Sie setzt den Rahmen fuer die Kartennavigation - ein Menue vertraegt weder Akkordeon noch Tabs.
     * FEHLT DER WERT, gilt KARTE.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    speisekarteForm?: DatabaseAppearancePropertiesSpeisekarteFormEnum;
    /**
     * Wie sich der Gast in der Speisekarte bewegt: Kategorien auf- und zuklappen, eine Kategorie je Reiter, alles untereinander mit mitlaufender Reiterleiste, oder gar keine Navigation.
     * KEINE BEDIENLEISTE: Das ist nicht das Navigationskonzept der Listen (Suche, Filter, Neu). Jenes gilt fuer den Besitzer in der Listenansicht und bleibt davon unberuehrt.
     * FEHLT DER WERT oder passt er nicht zur Form, gilt die Vorgabe der Form (Karte: AKKORDEON, Menue und Buffet: KAPITEL, Liste: KEINE).
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    speisekarteNavigation?: DatabaseAppearancePropertiesSpeisekarteNavigationEnum;
    /**
     * Wo die Inhalte zum Lokal stehen (Team, Textseiten, Zusatzstoffe und Allergene): hinter einem Burger-Menue, das von rechts hereingleitet, oder in einer Leiste am unteren Rand.
     * FEHLT DER WERT, gilt BURGER.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    speisekarteInfos?: DatabaseAppearancePropertiesSpeisekarteInfosEnum;
    /**
     * Wo die Zeichenerklaerung (Zusatzstoffe und Allergene) steht — Betreiber 23.10.2026.
     * SEITE        Als eigene Seite, erreichbar ueber Leiste oder
     *              Burger-Menue (Vorgabe, bisheriges Verhalten).
     * UNTER_KARTE  Direkt unter der Karte, nach der letzten Kategorie;
     *              der eigene Punkt in Leiste und Burger-Menue entfaellt.
     * AKKORDEON    Wie UNTER_KARTE, aber zugeklappt; der Gast oeffnet
     *              sie bei Bedarf.
     * 
     * FEHLT DER WERT, gilt SEITE.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    speisekarteZusatzstoffe?: DatabaseAppearancePropertiesSpeisekarteZusatzstoffeEnum;
    /**
     * Wo Kommentare der Detailmaske erscheinen.
     * MODAL   In einem eigenen Fenster (Vorgabe, heutiges Verhalten). INLINE  Eingebettet unten auf der Karte, ohne Fensterwechsel.
     * NICHT JE GERAET, anders als Aufbau und Knopfform: Es ist keine Frage des Platzes, sondern eine des Arbeitsstils — wer Kommentare eingebettet haben will, will das auf jedem Geraet. Deshalb steht die Angabe unter "Farben & Layout" und nicht im Navigations-Dialog (Vorgabe des Betreibers 28.08.2026).
     * Fehlt der Wert, gilt MODAL.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsCommentMode?: DatabaseAppearancePropertiesDetailsCommentModeEnum;
    /**
     * Hintergrund des Kopfbereichs. Bisher lebte dieser Wert im `inlineStyle` des Bereichs; als eigenes Feld laesst er sich aus dem Farbkonzept vorbelegen und unter "Layout" einstellen.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    headerBackgroundColor?: string;
    /**
     * Hintergrund des Fussbereichs, analog zu headerBackgroundColor.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    footerBackgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    colorScheme?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    secondaryColorScheme?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    bodyBackgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    stageBackgroundColor?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    ctaPrimaryColor?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    ctaSecondaryColor?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    ctaBorderRadius?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    ctaBorderWidth?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    selectionBtnPrimaryColor?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    selectionBtnSecondaryColor?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    selectionBtnBorderRadius?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    selectionBtnBorderWidth?: number;
    /**
     * RUECKFALL fuer Kategorie-Knoepfe: Farbe 1 (Rahmen und Schrift im nicht gewaehlten Zustand, Fuellung im gewaehlten). Gilt fuer jede Option, die KEINE eigene Farbe traegt. Bisher fiel die Anzeige auf die Knopffarben der Detailmaske zurueck -- eine Vorgabe, die niemand fuer Kategorien gewaehlt hatte.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    categoryTogglePrimaryColor?: string;
    /**
     * RUECKFALL fuer Kategorie-Knoepfe: Farbe 2 (Schrift im gewaehlten Zustand). Gegenstueck zu `categoryTogglePrimaryColor`.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    categoryToggleSecondaryColor?: string;
    /**
     * border-radius (px) for Kategorie-Toggle-Buttons
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    categoryToggleBorderRadius?: number;
    /**
     * border-width (px) for Kategorie-Toggle-Buttons
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    categoryToggleBorderWidth?: number;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseAppearanceProperties
     */
    headerFontSize?: DatabaseFontSizeEnum;
    /**
     * font family of database entries header
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    headerFontFamily?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    headerFontColor?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseAppearanceProperties
     */
    bodyFontSize?: DatabaseFontSizeEnum;
    /**
     * font family of database entries body
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    bodyFontFamily?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    bodyFontColor?: string;
    /**
     * font family of database entries header
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    footerFontFamily?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseAppearanceProperties
     */
    footerFontSize?: DatabaseFontSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    footerFontColor?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseAppearanceProperties
     */
    detailsFontSize?: DatabaseFontSizeEnum;
    /**
     * font family of details modal
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsFontFamily?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsFontColor?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseAppearanceProperties
     */
    detailsLabelFontSize?: DatabaseFontSizeEnum;
    /**
     * font family of labels in details modal
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsLabelFontFamily?: string;
    /**
     * font color of labels in details modal
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsLabelFontColor?: string;
    /**
     * Schriftart der UEBERSCHRIFT der Detailmaske -- also der Zeile, in der der Name des Datensatzes steht.
     * KLARSTELLUNG 29.08.2026 (Vorgabe des Betreibers): Diese drei Werte steuerten zuletzt die GRUPPENueberschrift und damit etwas anderes als ihr Name sagt. Fuer die Gruppen gibt es seither eigene Felder (`detailsGroupFont*`).
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsHeadingFontFamily?: string;
    /**
     * Schriftgroesse der Ueberschrift der Detailmaske
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsHeadingFontSize?: string;
    /**
     * Schriftfarbe der Ueberschrift. Leer heisst "nimm die Farbe aus dem Farbschema" -- nicht "farblos".
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsHeadingFontColor?: string;
    /**
     * Schriftart der GRUPPENUEBERSCHRIFT in der Detailmaske (Vorgabe des Betreibers 29.08.2026: "Dann fehlt eine Schrift fuer die Gruppierung auf der Seite der Detailanzeige. Fuer die Ueberschrift der Gruppierung wird aktuell Ueberschrift verwendet. Dies ist falsch").
     * WARUM EIGENE FELDER: Die Ueberschrift eines Datensatzes und die Ueberschrift einer Feldgruppe stehen in derselben Maske uebereinander und sollen sich unterscheiden duerfen -- die eine benennt den Datensatz, die andere gliedert seine Felder.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsGroupFontFamily?: string;
    /**
     * Schriftgroesse der Gruppenueberschrift
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsGroupFontSize?: string;
    /**
     * Schriftfarbe der Gruppenueberschrift. Leer heisst "nimm die Farbe aus dem Farbschema".
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsGroupFontColor?: string;
    /**
     * Schriftart des BESCHREIBUNGSTEXTES einer Feldgruppe -- die Zeile unter der Gruppenueberschrift (Vorgabe des Betreibers 31.08.2026: "Nur die Gruppierungen muessen noch ergaenzt werden. Gruppierung Ueberschrift und Gruppierung Text").
     * DIESELBE LUECKE WIE BEI DER UEBERSCHRIFT, eine Ebene tiefer: Der Beschreibungstext hing an `detailsHeading*`, verkleinert auf 40 Prozent. Damit liess er sich nicht aendern, ohne die Maskenueberschrift mitzuziehen -- und die benutzt diese Werte nicht einmal selbst.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsGroupTextFontFamily?: string;
    /**
     * Schriftgroesse des Beschreibungstextes einer Feldgruppe
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsGroupTextFontSize?: string;
    /**
     * Schriftfarbe des Beschreibungstextes einer Feldgruppe. Leer heisst "nimm die Farbe aus dem Farbschema".
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsGroupTextFontColor?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseAppearanceProperties
     */
    detailsDisplayFontSize?: DatabaseFontSizeEnum;
    /**
     * font family for display/view mode in details modal
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsDisplayFontFamily?: string;
    /**
     * font color for display/view mode in details modal
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsDisplayFontColor?: string;
    /**
     * color of primary buttons in details view (and toggle ON-track in YesNoField)
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailButtonPrimaryColor?: string;
    /**
     * color of secondary buttons in details view (and toggle OFF-track in YesNoField)
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailButtonSecondaryColor?: string;
    /**
     * background color of detail-button track (used as toggle-thumb color
     * in YesNoField — the round handle that slides between ON and OFF).
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailButtonBackgroundColor?: string;
    /**
     * zentrale Hintergrundfarbe fuer deaktivierte/nicht-ausgewaehlte
     * Feld-Zustaende in der Detail-Maske (Toggle-OFF, leere Upload-Trigger,
     * nicht-ausgewaehlte Sterne/Buttons/Karten). Default hellgrau.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsInactiveBgColor?: string;
    /**
     * zentrale Vordergrund-/Schriftfarbe fuer deaktivierte/nicht-
     * ausgewaehlte Feld-Zustaende in der Detail-Maske. Default dunkelgrau.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsInactiveFgColor?: string;
    /**
     * background color of the list view table header row
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    tableHeaderBackgroundColor?: string;
    /**
     * font color of the list view table header row
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    tableHeaderFontColor?: string;
    /**
     * background color behind list view rows (falls back to bodyBackgroundColor when unset)
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    tableRowBackgroundColor?: string;
    /**
     * font family used for grouping header rows in list views
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    groupingFontFamily?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseAppearanceProperties
     */
    groupingFontSize?: DatabaseFontSizeEnum;
    /**
     * font color of grouping header rows in list views
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    groupingFontColor?: string;
    /**
     * background color of grouping header rows in list views
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    groupingBackgroundColor?: string;
    /**
     * font family of the optional per-value grouping description text (next to grouping label)
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    groupingExtraTextFontFamily?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseAppearanceProperties
     */
    groupingExtraTextFontSize?: DatabaseFontSizeEnum;
    /**
     * font color of the optional per-value grouping description text
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    groupingExtraTextFontColor?: string;
    /**
     * Die Kontaktkarte (TPL_SUBSCRIBERCARD) zeigt ALLE Feldgruppen auf EINER Karte, untereinander, statt je Gruppe einen Schritt.
     * WARUM (Betreiber 07.10.2026): „Wenn ich mit den Feldgruppen arbeite, das geht, darf nur keine zweite Seite fuer die zweite Gruppe genommen werden." Bis dahin war die Feldgruppe bei dieser Vorlage DOPPELT belegt — Anordnungs-Werkzeug UND Seitenumbruch zugleich. Man konnte das eine nicht haben, ohne das andere zu bekommen.
     * FEHLT DER WERT, bleibt es beim Schritt je Gruppe — so war es immer, und eine bestehende Karte soll sich nicht von selbst umbauen.
     * DIE GRUPPENNAMEN WERDEN DANN ZU ABSCHNITTEN. Die Schrittanzeige entfaellt; der Absendeknopf steht einmal am Ende.
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    karteOhneSchritte?: boolean;
    /**
     * Seitenverhaeltnis der Kontaktkarte (TPL_SUBSCRIBERCARD).
     * AUS DEM PROTOTYPEN DES BETREIBERS (07.10.2026): Dort schaltet eine Leiste zwischen „Ganzer Bildschirm" und fuenf festen Verhaeltnissen um. Bis dahin hatte die Karte im Produkt gar keine Wahl — sie war auf halbe Breite und volle Hoehe verdrahtet.
     * FEHLT DER WERT, gilt VOLLFLAECHE: Die Karte nimmt den Platz, den sie braucht, wie bisher.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    karteFormat?: DatabaseAppearancePropertiesKarteFormatEnum;
    /**
     * Breite der Kontaktkarte in Prozent der verfuegbaren Flaeche. Fehlt der Wert, gilt 100.
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    karteBreitePercent?: number;
    /**
     * Waagerechte Lage der Kontaktkarte. Senkrecht steht sie immer mittig — so wie im Prototypen. Fehlt der Wert, gilt MITTE.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    karteLage?: DatabaseAppearancePropertiesKarteLageEnum;
    /**
     * Lage des runden Keyvisuals im Kopf der Kontaktkarte.
     * AUS DEM PROTOTYPEN: ein rundes Bild ueber der Ueberschrift, vier Lagen zur Wahl. Im Produkt gab es das Keyvisual bisher ueberhaupt nicht; oben stand nur das Bild, das die Vorschaltseite zufaellig als erstes `<img>` enthielt.
     * FEHLT DER WERT, gilt AUS — eine bestehende Karte bekommt also nicht ploetzlich ein Bild.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    keyvisualLage?: DatabaseAppearancePropertiesKeyvisualLageEnum;
    /**
     * 
     * @type {DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent}
     * @memberof DatabaseAppearanceProperties
     */
    questionnaireBodyWidthPercent?: DatabaseAppearancePropertiesQuestionnaireBodyWidthPercent;
    /**
     * 
     * @type {DatabaseAppearancePropertiesDetailsBodyWidthPercent}
     * @memberof DatabaseAppearanceProperties
     */
    detailsBodyWidthPercent?: DatabaseAppearancePropertiesDetailsBodyWidthPercent;
    /**
     * chart fill color (value/percentage portion) for circle and bar chart
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    chartColor1?: string;
    /**
     * chart rest color (remainder to 100%) for circle and bar chart
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    chartColor2?: string;
    /**
     * chart color 3 (reserved)
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    chartColor3?: string;
    /**
     * chart color 4 (reserved)
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    chartColor4?: string;
    /**
     * default items per page
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    defaultPageSize?: number;
    /**
     * 
     * @type {DatabaseFarbrollen}
     * @memberof DatabaseAppearanceProperties
     */
    farben?: DatabaseFarbrollen;
    /**
     * 
     * @type {DatabaseSchriftrollen}
     * @memberof DatabaseAppearanceProperties
     */
    schriftrollen?: DatabaseSchriftrollen;
    /**
     * 
     * @type {DatabaseNavigationProperties}
     * @memberof DatabaseAppearanceProperties
     */
    navigation?: DatabaseNavigationProperties;
    /**
     * ALT — wird durch `navigation` abgeloest. Bleibt vorerst stehen, damit bereits gespeicherte Datenbanken weiterlaufen, bis die Migration durch ist (/dbadmin/navigation-migration). frontend interaction mode
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    interactionMode?: DatabaseAppearancePropertiesInteractionModeEnum;
    /**
     * Newsboard-Ausgaben: Zeitraster, nach dem Artikel einer Ausgabe zugeordnet werden (Default DAY)
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    editionGranularity?: DatabaseAppearancePropertiesEditionGranularityEnum;
    /**
     * 
     * @type {DatabaseHeaderProperties}
     * @memberof DatabaseAppearanceProperties
     */
    header?: DatabaseHeaderProperties;
    /**
     * 
     * @type {DatabaseHeaderProperties}
     * @memberof DatabaseAppearanceProperties
     */
    footer?: DatabaseHeaderProperties;
    /**
     * 
     * @type {DatabaseHeaderProperties}
     * @memberof DatabaseAppearanceProperties
     */
    pagesHeader?: DatabaseHeaderProperties;
    /**
     * 
     * @type {DatabaseHeaderProperties}
     * @memberof DatabaseAppearanceProperties
     */
    pagesFooter?: DatabaseHeaderProperties;
    /**
     * 
     * @type {DatabaseContentPage}
     * @memberof DatabaseAppearanceProperties
     */
    pageDefaults?: DatabaseContentPage;
    /**
     * the selected ui template for this instance
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    uiTemplate?: string;
    /**
     * optional variant of UI Template
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    templateVariant?: string;
    /**
     * optional animation effect identifier — managed by Effects module
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    effect?: string;
    /**
     * size multiplier for effect particles (0.5–2.0)
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    effectSize?: number;
    /**
     * amount multiplier — scales how many particles are spawned (0.5–2.0)
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    effectAmount?: number;
    /**
     * speed multiplier for effect (0.5–2.0)
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    effectSpeed?: number;
    /**
     * effect duration in seconds; omitted = infinite
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    effectDurationSec?: number;
    /**
     * color source for effect: 'original' (built-in palette) or 'scheme' (use colorScheme)
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    effectColorMode?: string;
    /**
     * screen sections where effect is visible: any subset of ['header', 'body', 'footer']
     * @type {Array<string>}
     * @memberof DatabaseAppearanceProperties
     */
    effectScope?: Array<string>;
    /**
     * Welche Ansicht beim Oeffnen zuerst zu sehen ist. Sie wird nur genommen, wenn die Datenbank sie ueberhaupt anbieten kann -- sonst landete der Betrachter auf einer leeren Seite.
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    defaultView?: DatabaseAppearancePropertiesDefaultViewEnum;
    /**
     * 
     * @type {DatabaseAppearancePropertiesDefaultViewColumns}
     * @memberof DatabaseAppearanceProperties
     */
    defaultViewColumns?: DatabaseAppearancePropertiesDefaultViewColumns;
    /**
     * Zeilenhoehe der Datenanzeige, als FAKTOR der Schriftgroesse -- nicht als feste Pixelzahl. Wer die Schrift vergroessert, bekommt sonst abgeschnittene Zeilen; der Faktor waechst mit.
     * SCHMAL = 1,2 (viel auf einen Blick) - MITTEL = 1,5 (Vorgabe, angenehm lesbar) - HOCH = 2,0 (luftig, gut fuer Beruehrung).
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    zeilenhoehe?: DatabaseAppearancePropertiesZeilenhoeheEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseAppearanceProperties
     */
    respectFieldGroupsInPreview?: boolean;
    /**
     * flow of the fields in the details form
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsFieldAlignment?: DatabaseAppearancePropertiesDetailsFieldAlignmentEnum;
    /**
     * alignment of the labels in the details form
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsLabelAlignment?: DatabaseAppearancePropertiesDetailsLabelAlignmentEnum;
    /**
     * the background color of the details modal
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsBackgroundColor?: string;
    /**
     * border style of the details modal
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsBorderType?: DatabaseAppearancePropertiesDetailsBorderTypeEnum;
    /**
     * the border color of the details modal
     * @type {string}
     * @memberof DatabaseAppearanceProperties
     */
    detailsBorderColor?: string;
    /**
     * 
     * @type {DatabaseAppearanceFieldLayout}
     * @memberof DatabaseAppearanceProperties
     */
    detailsFieldLayout?: DatabaseAppearanceFieldLayout;
    /**
     * per-field column widths (px) for the list view, keyed by field ID
     * @type {{ [key: string]: number; }}
     * @memberof DatabaseAppearanceProperties
     */
    listColumnWidths?: { [key: string]: number; };
    /**
     * number of sticky (pinned) columns in the list view
     * @type {number}
     * @memberof DatabaseAppearanceProperties
     */
    listStickyColumns?: number;
    /**
     * IDs of virtual columns hidden in list view by the user
     * @type {Array<string>}
     * @memberof DatabaseAppearanceProperties
     */
    hiddenVirtualColumns?: Array<string>;
    /**
     * IDs of virtual columns disabled for this template or database by superadmin
     * @type {Array<string>}
     * @memberof DatabaseAppearanceProperties
     */
    disabledVirtualColumns?: Array<string>;
    /**
     * Design effects applied by color presets (gradients, shadows, transitions etc.)
     * @type {{ [key: string]: string; }}
     * @memberof DatabaseAppearanceProperties
     */
    designEffects?: { [key: string]: string; };
}


/**
 * @export
 */
export const DatabaseAppearancePropertiesBibDiashowEnum = {
    Fototisch: 'FOTOTISCH',
    Ueberblenden: 'UEBERBLENDEN',
    Schieben: 'SCHIEBEN',
    Kenburns: 'KENBURNS',
    Flip: 'FLIP',
    Unscharf: 'UNSCHARF',
    Blitz: 'BLITZ',
    Drehen: 'DREHEN',
    Wuerfel: 'WUERFEL',
    Jalousie: 'JALOUSIE'
} as const;
export type DatabaseAppearancePropertiesBibDiashowEnum = typeof DatabaseAppearancePropertiesBibDiashowEnum[keyof typeof DatabaseAppearancePropertiesBibDiashowEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesBibKarussellEnum = {
    Galerie: 'GALERIE',
    Regal: 'REGAL'
} as const;
export type DatabaseAppearancePropertiesBibKarussellEnum = typeof DatabaseAppearancePropertiesBibKarussellEnum[keyof typeof DatabaseAppearancePropertiesBibKarussellEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesBibliothekStilEnum = {
    Gastro: 'GASTRO',
    Lkw: 'LKW',
    Zug: 'ZUG',
    Seilbahn: 'SEILBAHN',
    Bude: 'BUDE',
    Vinyl: 'VINYL',
    Platte: 'PLATTE',
    Teller: 'TELLER',
    Bestseller: 'BESTSELLER',
    Regal: 'REGAL',
    Prospekt: 'PROSPEKT',
    Ordner: 'ORDNER',
    Fallblatt: 'FALLBLATT',
    Gemaelde: 'GEMAELDE',
    Kartei: 'KARTEI',
    Polaroid: 'POLAROID',
    Apotheke: 'APOTHEKE',
    Lokschuppen: 'LOKSCHUPPEN',
    Auto: 'AUTO',
    Wein: 'WEIN',
    Handbuch: 'HANDBUCH',
    Plattensammlung: 'PLATTENSAMMLUNG',
    Wiki: 'WIKI',
    Film: 'FILM',
    Fotoalbum: 'FOTOALBUM',
    Cocktail: 'COCKTAIL',
    Tagebuch: 'TAGEBUCH'
} as const;
export type DatabaseAppearancePropertiesBibliothekStilEnum = typeof DatabaseAppearancePropertiesBibliothekStilEnum[keyof typeof DatabaseAppearancePropertiesBibliothekStilEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesSpeisekarteFormEnum = {
    Karte: 'KARTE',
    Flat: 'FLAT',
    Menue: 'MENUE',
    Buffet: 'BUFFET'
} as const;
export type DatabaseAppearancePropertiesSpeisekarteFormEnum = typeof DatabaseAppearancePropertiesSpeisekarteFormEnum[keyof typeof DatabaseAppearancePropertiesSpeisekarteFormEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesSpeisekarteNavigationEnum = {
    Akkordeon: 'AKKORDEON',
    Tabs: 'TABS',
    Kapitel: 'KAPITEL',
    Keine: 'KEINE'
} as const;
export type DatabaseAppearancePropertiesSpeisekarteNavigationEnum = typeof DatabaseAppearancePropertiesSpeisekarteNavigationEnum[keyof typeof DatabaseAppearancePropertiesSpeisekarteNavigationEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesSpeisekarteInfosEnum = {
    Burger: 'BURGER',
    Leiste: 'LEISTE'
} as const;
export type DatabaseAppearancePropertiesSpeisekarteInfosEnum = typeof DatabaseAppearancePropertiesSpeisekarteInfosEnum[keyof typeof DatabaseAppearancePropertiesSpeisekarteInfosEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesSpeisekarteZusatzstoffeEnum = {
    Seite: 'SEITE',
    UnterKarte: 'UNTER_KARTE',
    Akkordeon: 'AKKORDEON'
} as const;
export type DatabaseAppearancePropertiesSpeisekarteZusatzstoffeEnum = typeof DatabaseAppearancePropertiesSpeisekarteZusatzstoffeEnum[keyof typeof DatabaseAppearancePropertiesSpeisekarteZusatzstoffeEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesDetailsCommentModeEnum = {
    Modal: 'MODAL',
    Inline: 'INLINE'
} as const;
export type DatabaseAppearancePropertiesDetailsCommentModeEnum = typeof DatabaseAppearancePropertiesDetailsCommentModeEnum[keyof typeof DatabaseAppearancePropertiesDetailsCommentModeEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesKarteFormatEnum = {
    Vollflaeche: 'VOLLFLAECHE',
    Quadrat11: 'QUADRAT_1_1',
    Quer32: 'QUER_3_2',
    Quer169: 'QUER_16_9',
    Hoch23: 'HOCH_2_3',
    Hoch916: 'HOCH_9_16'
} as const;
export type DatabaseAppearancePropertiesKarteFormatEnum = typeof DatabaseAppearancePropertiesKarteFormatEnum[keyof typeof DatabaseAppearancePropertiesKarteFormatEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesKarteLageEnum = {
    Links: 'LINKS',
    Mitte: 'MITTE',
    Rechts: 'RECHTS'
} as const;
export type DatabaseAppearancePropertiesKarteLageEnum = typeof DatabaseAppearancePropertiesKarteLageEnum[keyof typeof DatabaseAppearancePropertiesKarteLageEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesKeyvisualLageEnum = {
    Aus: 'AUS',
    Mitte: 'MITTE',
    ObenLinks: 'OBEN_LINKS',
    ObenRechts: 'OBEN_RECHTS'
} as const;
export type DatabaseAppearancePropertiesKeyvisualLageEnum = typeof DatabaseAppearancePropertiesKeyvisualLageEnum[keyof typeof DatabaseAppearancePropertiesKeyvisualLageEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesInteractionModeEnum = {
    Sidebar: 'SIDEBAR',
    BurgerMenu: 'BURGER_MENU',
    BurgerMenuLight: 'BURGER_MENU_LIGHT',
    Buttons: 'BUTTONS',
    ButtonsLight: 'BUTTONS_LIGHT',
    Search: 'SEARCH',
    None: 'NONE'
} as const;
export type DatabaseAppearancePropertiesInteractionModeEnum = typeof DatabaseAppearancePropertiesInteractionModeEnum[keyof typeof DatabaseAppearancePropertiesInteractionModeEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesEditionGranularityEnum = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH',
    Quarter: 'QUARTER'
} as const;
export type DatabaseAppearancePropertiesEditionGranularityEnum = typeof DatabaseAppearancePropertiesEditionGranularityEnum[keyof typeof DatabaseAppearancePropertiesEditionGranularityEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesDefaultViewEnum = {
    List: 'LIST',
    Grid: 'GRID',
    Gallery: 'GALLERY',
    Children: 'CHILDREN',
    Kanban: 'KANBAN',
    Verlauf: 'VERLAUF'
} as const;
export type DatabaseAppearancePropertiesDefaultViewEnum = typeof DatabaseAppearancePropertiesDefaultViewEnum[keyof typeof DatabaseAppearancePropertiesDefaultViewEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesZeilenhoeheEnum = {
    Schmal: 'SCHMAL',
    Mittel: 'MITTEL',
    Hoch: 'HOCH'
} as const;
export type DatabaseAppearancePropertiesZeilenhoeheEnum = typeof DatabaseAppearancePropertiesZeilenhoeheEnum[keyof typeof DatabaseAppearancePropertiesZeilenhoeheEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesDetailsFieldAlignmentEnum = {
    LeftRight: 'LEFT_RIGHT',
    TopBottom: 'TOP_BOTTOM'
} as const;
export type DatabaseAppearancePropertiesDetailsFieldAlignmentEnum = typeof DatabaseAppearancePropertiesDetailsFieldAlignmentEnum[keyof typeof DatabaseAppearancePropertiesDetailsFieldAlignmentEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesDetailsLabelAlignmentEnum = {
    Top: 'TOP',
    TopCentered: 'TOP_CENTERED',
    Left: 'LEFT',
    Right: 'RIGHT'
} as const;
export type DatabaseAppearancePropertiesDetailsLabelAlignmentEnum = typeof DatabaseAppearancePropertiesDetailsLabelAlignmentEnum[keyof typeof DatabaseAppearancePropertiesDetailsLabelAlignmentEnum];

/**
 * @export
 */
export const DatabaseAppearancePropertiesDetailsBorderTypeEnum = {
    Full: 'FULL',
    Bottom: 'BOTTOM',
    None: 'NONE'
} as const;
export type DatabaseAppearancePropertiesDetailsBorderTypeEnum = typeof DatabaseAppearancePropertiesDetailsBorderTypeEnum[keyof typeof DatabaseAppearancePropertiesDetailsBorderTypeEnum];


/**
 * Check if a given object implements the DatabaseAppearanceProperties interface.
 */
export function instanceOfDatabaseAppearanceProperties(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseAppearancePropertiesFromJSON(json: any): DatabaseAppearanceProperties {
    return DatabaseAppearancePropertiesFromJSONTyped(json, false);
}

export function DatabaseAppearancePropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseAppearanceProperties {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hideHeader': !exists(json, 'hideHeader') ? undefined : json['hideHeader'],
        'hideContent': !exists(json, 'hideContent') ? undefined : json['hideContent'],
        'hideColumnSlider': !exists(json, 'hideColumnSlider') ? undefined : json['hideColumnSlider'],
        'hidePaginationBar': !exists(json, 'hidePaginationBar') ? undefined : json['hidePaginationBar'],
        'hideFooter': !exists(json, 'hideFooter') ? undefined : json['hideFooter'],
        'hideAccountIcon': !exists(json, 'hideAccountIcon') ? undefined : json['hideAccountIcon'],
        'mobileCardView': !exists(json, 'mobileCardView') ? undefined : json['mobileCardView'],
        'farbkonzept': !exists(json, 'farbkonzept') ? undefined : json['farbkonzept'],
        'detailmaske': !exists(json, 'detailmaske') ? undefined : DatabaseDetailmaskePropertiesFromJSON(json['detailmaske']),
        'bibDiashow': !exists(json, 'bibDiashow') ? undefined : json['bibDiashow'],
        'bibDiashowTakt': !exists(json, 'bibDiashowTakt') ? undefined : json['bibDiashowTakt'],
        'bibKarussell': !exists(json, 'bibKarussell') ? undefined : json['bibKarussell'],
        'bibliothekStil': !exists(json, 'bibliothekStil') ? undefined : json['bibliothekStil'],
        'bibBuchstabenleiste': !exists(json, 'bibBuchstabenleiste') ? undefined : json['bibBuchstabenleiste'],
        'bibStichwortleiste': !exists(json, 'bibStichwortleiste') ? undefined : json['bibStichwortleiste'],
        'adventStart': !exists(json, 'adventStart') ? undefined : json['adventStart'],
        'adventNachtraeglich': !exists(json, 'adventNachtraeglich') ? undefined : json['adventNachtraeglich'],
        'speisekarteForm': !exists(json, 'speisekarteForm') ? undefined : json['speisekarteForm'],
        'speisekarteNavigation': !exists(json, 'speisekarteNavigation') ? undefined : json['speisekarteNavigation'],
        'speisekarteInfos': !exists(json, 'speisekarteInfos') ? undefined : json['speisekarteInfos'],
        'speisekarteZusatzstoffe': !exists(json, 'speisekarteZusatzstoffe') ? undefined : json['speisekarteZusatzstoffe'],
        'detailsCommentMode': !exists(json, 'detailsCommentMode') ? undefined : json['detailsCommentMode'],
        'headerBackgroundColor': !exists(json, 'headerBackgroundColor') ? undefined : json['headerBackgroundColor'],
        'footerBackgroundColor': !exists(json, 'footerBackgroundColor') ? undefined : json['footerBackgroundColor'],
        'colorScheme': !exists(json, 'colorScheme') ? undefined : json['colorScheme'],
        'secondaryColorScheme': !exists(json, 'secondaryColorScheme') ? undefined : json['secondaryColorScheme'],
        'bodyBackgroundColor': !exists(json, 'bodyBackgroundColor') ? undefined : json['bodyBackgroundColor'],
        'stageBackgroundColor': !exists(json, 'stageBackgroundColor') ? undefined : json['stageBackgroundColor'],
        'ctaPrimaryColor': !exists(json, 'ctaPrimaryColor') ? undefined : json['ctaPrimaryColor'],
        'ctaSecondaryColor': !exists(json, 'ctaSecondaryColor') ? undefined : json['ctaSecondaryColor'],
        'ctaBorderRadius': !exists(json, 'ctaBorderRadius') ? undefined : json['ctaBorderRadius'],
        'ctaBorderWidth': !exists(json, 'ctaBorderWidth') ? undefined : json['ctaBorderWidth'],
        'selectionBtnPrimaryColor': !exists(json, 'selectionBtnPrimaryColor') ? undefined : json['selectionBtnPrimaryColor'],
        'selectionBtnSecondaryColor': !exists(json, 'selectionBtnSecondaryColor') ? undefined : json['selectionBtnSecondaryColor'],
        'selectionBtnBorderRadius': !exists(json, 'selectionBtnBorderRadius') ? undefined : json['selectionBtnBorderRadius'],
        'selectionBtnBorderWidth': !exists(json, 'selectionBtnBorderWidth') ? undefined : json['selectionBtnBorderWidth'],
        'categoryTogglePrimaryColor': !exists(json, 'categoryTogglePrimaryColor') ? undefined : json['categoryTogglePrimaryColor'],
        'categoryToggleSecondaryColor': !exists(json, 'categoryToggleSecondaryColor') ? undefined : json['categoryToggleSecondaryColor'],
        'categoryToggleBorderRadius': !exists(json, 'categoryToggleBorderRadius') ? undefined : json['categoryToggleBorderRadius'],
        'categoryToggleBorderWidth': !exists(json, 'categoryToggleBorderWidth') ? undefined : json['categoryToggleBorderWidth'],
        'headerFontSize': !exists(json, 'headerFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['headerFontSize']),
        'headerFontFamily': !exists(json, 'headerFontFamily') ? undefined : json['headerFontFamily'],
        'headerFontColor': !exists(json, 'headerFontColor') ? undefined : json['headerFontColor'],
        'bodyFontSize': !exists(json, 'bodyFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['bodyFontSize']),
        'bodyFontFamily': !exists(json, 'bodyFontFamily') ? undefined : json['bodyFontFamily'],
        'bodyFontColor': !exists(json, 'bodyFontColor') ? undefined : json['bodyFontColor'],
        'footerFontFamily': !exists(json, 'footerFontFamily') ? undefined : json['footerFontFamily'],
        'footerFontSize': !exists(json, 'footerFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['footerFontSize']),
        'footerFontColor': !exists(json, 'footerFontColor') ? undefined : json['footerFontColor'],
        'detailsFontSize': !exists(json, 'detailsFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['detailsFontSize']),
        'detailsFontFamily': !exists(json, 'detailsFontFamily') ? undefined : json['detailsFontFamily'],
        'detailsFontColor': !exists(json, 'detailsFontColor') ? undefined : json['detailsFontColor'],
        'detailsLabelFontSize': !exists(json, 'detailsLabelFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['detailsLabelFontSize']),
        'detailsLabelFontFamily': !exists(json, 'detailsLabelFontFamily') ? undefined : json['detailsLabelFontFamily'],
        'detailsLabelFontColor': !exists(json, 'detailsLabelFontColor') ? undefined : json['detailsLabelFontColor'],
        'detailsHeadingFontFamily': !exists(json, 'detailsHeadingFontFamily') ? undefined : json['detailsHeadingFontFamily'],
        'detailsHeadingFontSize': !exists(json, 'detailsHeadingFontSize') ? undefined : json['detailsHeadingFontSize'],
        'detailsHeadingFontColor': !exists(json, 'detailsHeadingFontColor') ? undefined : json['detailsHeadingFontColor'],
        'detailsGroupFontFamily': !exists(json, 'detailsGroupFontFamily') ? undefined : json['detailsGroupFontFamily'],
        'detailsGroupFontSize': !exists(json, 'detailsGroupFontSize') ? undefined : json['detailsGroupFontSize'],
        'detailsGroupFontColor': !exists(json, 'detailsGroupFontColor') ? undefined : json['detailsGroupFontColor'],
        'detailsGroupTextFontFamily': !exists(json, 'detailsGroupTextFontFamily') ? undefined : json['detailsGroupTextFontFamily'],
        'detailsGroupTextFontSize': !exists(json, 'detailsGroupTextFontSize') ? undefined : json['detailsGroupTextFontSize'],
        'detailsGroupTextFontColor': !exists(json, 'detailsGroupTextFontColor') ? undefined : json['detailsGroupTextFontColor'],
        'detailsDisplayFontSize': !exists(json, 'detailsDisplayFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['detailsDisplayFontSize']),
        'detailsDisplayFontFamily': !exists(json, 'detailsDisplayFontFamily') ? undefined : json['detailsDisplayFontFamily'],
        'detailsDisplayFontColor': !exists(json, 'detailsDisplayFontColor') ? undefined : json['detailsDisplayFontColor'],
        'detailButtonPrimaryColor': !exists(json, 'detailButtonPrimaryColor') ? undefined : json['detailButtonPrimaryColor'],
        'detailButtonSecondaryColor': !exists(json, 'detailButtonSecondaryColor') ? undefined : json['detailButtonSecondaryColor'],
        'detailButtonBackgroundColor': !exists(json, 'detailButtonBackgroundColor') ? undefined : json['detailButtonBackgroundColor'],
        'detailsInactiveBgColor': !exists(json, 'detailsInactiveBgColor') ? undefined : json['detailsInactiveBgColor'],
        'detailsInactiveFgColor': !exists(json, 'detailsInactiveFgColor') ? undefined : json['detailsInactiveFgColor'],
        'tableHeaderBackgroundColor': !exists(json, 'tableHeaderBackgroundColor') ? undefined : json['tableHeaderBackgroundColor'],
        'tableHeaderFontColor': !exists(json, 'tableHeaderFontColor') ? undefined : json['tableHeaderFontColor'],
        'tableRowBackgroundColor': !exists(json, 'tableRowBackgroundColor') ? undefined : json['tableRowBackgroundColor'],
        'groupingFontFamily': !exists(json, 'groupingFontFamily') ? undefined : json['groupingFontFamily'],
        'groupingFontSize': !exists(json, 'groupingFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['groupingFontSize']),
        'groupingFontColor': !exists(json, 'groupingFontColor') ? undefined : json['groupingFontColor'],
        'groupingBackgroundColor': !exists(json, 'groupingBackgroundColor') ? undefined : json['groupingBackgroundColor'],
        'groupingExtraTextFontFamily': !exists(json, 'groupingExtraTextFontFamily') ? undefined : json['groupingExtraTextFontFamily'],
        'groupingExtraTextFontSize': !exists(json, 'groupingExtraTextFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['groupingExtraTextFontSize']),
        'groupingExtraTextFontColor': !exists(json, 'groupingExtraTextFontColor') ? undefined : json['groupingExtraTextFontColor'],
        'karteOhneSchritte': !exists(json, 'karteOhneSchritte') ? undefined : json['karteOhneSchritte'],
        'karteFormat': !exists(json, 'karteFormat') ? undefined : json['karteFormat'],
        'karteBreitePercent': !exists(json, 'karteBreitePercent') ? undefined : json['karteBreitePercent'],
        'karteLage': !exists(json, 'karteLage') ? undefined : json['karteLage'],
        'keyvisualLage': !exists(json, 'keyvisualLage') ? undefined : json['keyvisualLage'],
        'questionnaireBodyWidthPercent': !exists(json, 'questionnaireBodyWidthPercent') ? undefined : DatabaseAppearancePropertiesQuestionnaireBodyWidthPercentFromJSON(json['questionnaireBodyWidthPercent']),
        'detailsBodyWidthPercent': !exists(json, 'detailsBodyWidthPercent') ? undefined : DatabaseAppearancePropertiesDetailsBodyWidthPercentFromJSON(json['detailsBodyWidthPercent']),
        'chartColor1': !exists(json, 'chartColor1') ? undefined : json['chartColor1'],
        'chartColor2': !exists(json, 'chartColor2') ? undefined : json['chartColor2'],
        'chartColor3': !exists(json, 'chartColor3') ? undefined : json['chartColor3'],
        'chartColor4': !exists(json, 'chartColor4') ? undefined : json['chartColor4'],
        'defaultPageSize': !exists(json, 'defaultPageSize') ? undefined : json['defaultPageSize'],
        'farben': !exists(json, 'farben') ? undefined : DatabaseFarbrollenFromJSON(json['farben']),
        'schriftrollen': !exists(json, 'schriftrollen') ? undefined : DatabaseSchriftrollenFromJSON(json['schriftrollen']),
        'navigation': !exists(json, 'navigation') ? undefined : DatabaseNavigationPropertiesFromJSON(json['navigation']),
        'interactionMode': !exists(json, 'interactionMode') ? undefined : json['interactionMode'],
        'editionGranularity': !exists(json, 'editionGranularity') ? undefined : json['editionGranularity'],
        'header': !exists(json, 'header') ? undefined : DatabaseHeaderPropertiesFromJSON(json['header']),
        'footer': !exists(json, 'footer') ? undefined : DatabaseHeaderPropertiesFromJSON(json['footer']),
        'pagesHeader': !exists(json, 'pagesHeader') ? undefined : DatabaseHeaderPropertiesFromJSON(json['pagesHeader']),
        'pagesFooter': !exists(json, 'pagesFooter') ? undefined : DatabaseHeaderPropertiesFromJSON(json['pagesFooter']),
        'pageDefaults': !exists(json, 'pageDefaults') ? undefined : DatabaseContentPageFromJSON(json['pageDefaults']),
        'uiTemplate': !exists(json, 'uiTemplate') ? undefined : json['uiTemplate'],
        'templateVariant': !exists(json, 'templateVariant') ? undefined : json['templateVariant'],
        'effect': !exists(json, 'effect') ? undefined : json['effect'],
        'effectSize': !exists(json, 'effectSize') ? undefined : json['effectSize'],
        'effectAmount': !exists(json, 'effectAmount') ? undefined : json['effectAmount'],
        'effectSpeed': !exists(json, 'effectSpeed') ? undefined : json['effectSpeed'],
        'effectDurationSec': !exists(json, 'effectDurationSec') ? undefined : json['effectDurationSec'],
        'effectColorMode': !exists(json, 'effectColorMode') ? undefined : json['effectColorMode'],
        'effectScope': !exists(json, 'effectScope') ? undefined : json['effectScope'],
        'defaultView': !exists(json, 'defaultView') ? undefined : json['defaultView'],
        'defaultViewColumns': !exists(json, 'defaultViewColumns') ? undefined : DatabaseAppearancePropertiesDefaultViewColumnsFromJSON(json['defaultViewColumns']),
        'zeilenhoehe': !exists(json, 'zeilenhoehe') ? undefined : json['zeilenhoehe'],
        'respectFieldGroupsInPreview': !exists(json, 'respectFieldGroupsInPreview') ? undefined : json['respectFieldGroupsInPreview'],
        'detailsFieldAlignment': !exists(json, 'detailsFieldAlignment') ? undefined : json['detailsFieldAlignment'],
        'detailsLabelAlignment': !exists(json, 'detailsLabelAlignment') ? undefined : json['detailsLabelAlignment'],
        'detailsBackgroundColor': !exists(json, 'detailsBackgroundColor') ? undefined : json['detailsBackgroundColor'],
        'detailsBorderType': !exists(json, 'detailsBorderType') ? undefined : json['detailsBorderType'],
        'detailsBorderColor': !exists(json, 'detailsBorderColor') ? undefined : json['detailsBorderColor'],
        'detailsFieldLayout': !exists(json, 'detailsFieldLayout') ? undefined : DatabaseAppearanceFieldLayoutFromJSON(json['detailsFieldLayout']),
        'listColumnWidths': !exists(json, 'listColumnWidths') ? undefined : json['listColumnWidths'],
        'listStickyColumns': !exists(json, 'listStickyColumns') ? undefined : json['listStickyColumns'],
        'hiddenVirtualColumns': !exists(json, 'hiddenVirtualColumns') ? undefined : json['hiddenVirtualColumns'],
        'disabledVirtualColumns': !exists(json, 'disabledVirtualColumns') ? undefined : json['disabledVirtualColumns'],
        'designEffects': !exists(json, 'designEffects') ? undefined : json['designEffects'],
    };
}

export function DatabaseAppearancePropertiesToJSON(value?: DatabaseAppearanceProperties | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hideHeader': value.hideHeader,
        'hideContent': value.hideContent,
        'hideColumnSlider': value.hideColumnSlider,
        'hidePaginationBar': value.hidePaginationBar,
        'hideFooter': value.hideFooter,
        'hideAccountIcon': value.hideAccountIcon,
        'mobileCardView': value.mobileCardView,
        'farbkonzept': value.farbkonzept,
        'detailmaske': DatabaseDetailmaskePropertiesToJSON(value.detailmaske),
        'bibDiashow': value.bibDiashow,
        'bibDiashowTakt': value.bibDiashowTakt,
        'bibKarussell': value.bibKarussell,
        'bibliothekStil': value.bibliothekStil,
        'bibBuchstabenleiste': value.bibBuchstabenleiste,
        'bibStichwortleiste': value.bibStichwortleiste,
        'adventStart': value.adventStart,
        'adventNachtraeglich': value.adventNachtraeglich,
        'speisekarteForm': value.speisekarteForm,
        'speisekarteNavigation': value.speisekarteNavigation,
        'speisekarteInfos': value.speisekarteInfos,
        'speisekarteZusatzstoffe': value.speisekarteZusatzstoffe,
        'detailsCommentMode': value.detailsCommentMode,
        'headerBackgroundColor': value.headerBackgroundColor,
        'footerBackgroundColor': value.footerBackgroundColor,
        'colorScheme': value.colorScheme,
        'secondaryColorScheme': value.secondaryColorScheme,
        'bodyBackgroundColor': value.bodyBackgroundColor,
        'stageBackgroundColor': value.stageBackgroundColor,
        'ctaPrimaryColor': value.ctaPrimaryColor,
        'ctaSecondaryColor': value.ctaSecondaryColor,
        'ctaBorderRadius': value.ctaBorderRadius,
        'ctaBorderWidth': value.ctaBorderWidth,
        'selectionBtnPrimaryColor': value.selectionBtnPrimaryColor,
        'selectionBtnSecondaryColor': value.selectionBtnSecondaryColor,
        'selectionBtnBorderRadius': value.selectionBtnBorderRadius,
        'selectionBtnBorderWidth': value.selectionBtnBorderWidth,
        'categoryTogglePrimaryColor': value.categoryTogglePrimaryColor,
        'categoryToggleSecondaryColor': value.categoryToggleSecondaryColor,
        'categoryToggleBorderRadius': value.categoryToggleBorderRadius,
        'categoryToggleBorderWidth': value.categoryToggleBorderWidth,
        'headerFontSize': DatabaseFontSizeEnumToJSON(value.headerFontSize),
        'headerFontFamily': value.headerFontFamily,
        'headerFontColor': value.headerFontColor,
        'bodyFontSize': DatabaseFontSizeEnumToJSON(value.bodyFontSize),
        'bodyFontFamily': value.bodyFontFamily,
        'bodyFontColor': value.bodyFontColor,
        'footerFontFamily': value.footerFontFamily,
        'footerFontSize': DatabaseFontSizeEnumToJSON(value.footerFontSize),
        'footerFontColor': value.footerFontColor,
        'detailsFontSize': DatabaseFontSizeEnumToJSON(value.detailsFontSize),
        'detailsFontFamily': value.detailsFontFamily,
        'detailsFontColor': value.detailsFontColor,
        'detailsLabelFontSize': DatabaseFontSizeEnumToJSON(value.detailsLabelFontSize),
        'detailsLabelFontFamily': value.detailsLabelFontFamily,
        'detailsLabelFontColor': value.detailsLabelFontColor,
        'detailsHeadingFontFamily': value.detailsHeadingFontFamily,
        'detailsHeadingFontSize': value.detailsHeadingFontSize,
        'detailsHeadingFontColor': value.detailsHeadingFontColor,
        'detailsGroupFontFamily': value.detailsGroupFontFamily,
        'detailsGroupFontSize': value.detailsGroupFontSize,
        'detailsGroupFontColor': value.detailsGroupFontColor,
        'detailsGroupTextFontFamily': value.detailsGroupTextFontFamily,
        'detailsGroupTextFontSize': value.detailsGroupTextFontSize,
        'detailsGroupTextFontColor': value.detailsGroupTextFontColor,
        'detailsDisplayFontSize': DatabaseFontSizeEnumToJSON(value.detailsDisplayFontSize),
        'detailsDisplayFontFamily': value.detailsDisplayFontFamily,
        'detailsDisplayFontColor': value.detailsDisplayFontColor,
        'detailButtonPrimaryColor': value.detailButtonPrimaryColor,
        'detailButtonSecondaryColor': value.detailButtonSecondaryColor,
        'detailButtonBackgroundColor': value.detailButtonBackgroundColor,
        'detailsInactiveBgColor': value.detailsInactiveBgColor,
        'detailsInactiveFgColor': value.detailsInactiveFgColor,
        'tableHeaderBackgroundColor': value.tableHeaderBackgroundColor,
        'tableHeaderFontColor': value.tableHeaderFontColor,
        'tableRowBackgroundColor': value.tableRowBackgroundColor,
        'groupingFontFamily': value.groupingFontFamily,
        'groupingFontSize': DatabaseFontSizeEnumToJSON(value.groupingFontSize),
        'groupingFontColor': value.groupingFontColor,
        'groupingBackgroundColor': value.groupingBackgroundColor,
        'groupingExtraTextFontFamily': value.groupingExtraTextFontFamily,
        'groupingExtraTextFontSize': DatabaseFontSizeEnumToJSON(value.groupingExtraTextFontSize),
        'groupingExtraTextFontColor': value.groupingExtraTextFontColor,
        'karteOhneSchritte': value.karteOhneSchritte,
        'karteFormat': value.karteFormat,
        'karteBreitePercent': value.karteBreitePercent,
        'karteLage': value.karteLage,
        'keyvisualLage': value.keyvisualLage,
        'questionnaireBodyWidthPercent': DatabaseAppearancePropertiesQuestionnaireBodyWidthPercentToJSON(value.questionnaireBodyWidthPercent),
        'detailsBodyWidthPercent': DatabaseAppearancePropertiesDetailsBodyWidthPercentToJSON(value.detailsBodyWidthPercent),
        'chartColor1': value.chartColor1,
        'chartColor2': value.chartColor2,
        'chartColor3': value.chartColor3,
        'chartColor4': value.chartColor4,
        'defaultPageSize': value.defaultPageSize,
        'farben': DatabaseFarbrollenToJSON(value.farben),
        'schriftrollen': DatabaseSchriftrollenToJSON(value.schriftrollen),
        'navigation': DatabaseNavigationPropertiesToJSON(value.navigation),
        'interactionMode': value.interactionMode,
        'editionGranularity': value.editionGranularity,
        'header': DatabaseHeaderPropertiesToJSON(value.header),
        'footer': DatabaseHeaderPropertiesToJSON(value.footer),
        'pagesHeader': DatabaseHeaderPropertiesToJSON(value.pagesHeader),
        'pagesFooter': DatabaseHeaderPropertiesToJSON(value.pagesFooter),
        'pageDefaults': DatabaseContentPageToJSON(value.pageDefaults),
        'uiTemplate': value.uiTemplate,
        'templateVariant': value.templateVariant,
        'effect': value.effect,
        'effectSize': value.effectSize,
        'effectAmount': value.effectAmount,
        'effectSpeed': value.effectSpeed,
        'effectDurationSec': value.effectDurationSec,
        'effectColorMode': value.effectColorMode,
        'effectScope': value.effectScope,
        'defaultView': value.defaultView,
        'defaultViewColumns': DatabaseAppearancePropertiesDefaultViewColumnsToJSON(value.defaultViewColumns),
        'zeilenhoehe': value.zeilenhoehe,
        'respectFieldGroupsInPreview': value.respectFieldGroupsInPreview,
        'detailsFieldAlignment': value.detailsFieldAlignment,
        'detailsLabelAlignment': value.detailsLabelAlignment,
        'detailsBackgroundColor': value.detailsBackgroundColor,
        'detailsBorderType': value.detailsBorderType,
        'detailsBorderColor': value.detailsBorderColor,
        'detailsFieldLayout': DatabaseAppearanceFieldLayoutToJSON(value.detailsFieldLayout),
        'listColumnWidths': value.listColumnWidths,
        'listStickyColumns': value.listStickyColumns,
        'hiddenVirtualColumns': value.hiddenVirtualColumns,
        'disabledVirtualColumns': value.disabledVirtualColumns,
        'designEffects': value.designEffects,
    };
}

